import { Navigate, Outlet } from "react-router-dom";
import { useAppConfig } from "./AppConfigContext";

const ConMesasRoute = () => {
  const { config, loading, initialized } = useAppConfig();

  if (!initialized || loading) {
    return null;
  }

  return config?.conMesas === true ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default ConMesasRoute;
